import React from "react";
import {Backdrop} from "@mui/material";
import CustomLoader from "./CustomLoader";

const CustomBackdrop = ({open, children = true}) => {
    return <Backdrop open={open} sx={{zIndex: 10000}} children={children ? <CustomLoader color={'accent'}/> : null}/>;
}

export default CustomBackdrop